import { logEvent, analytics } from "../../firebaseConfig";

export function getUtcTimestamp(localTimestamp) {
  if (!localTimestamp) {
    return null;
  }

  const date = new Date(localTimestamp);
  return date.toISOString();
}

export function trackEvent(event, params) {
  if (analytics) {
    logEvent(analytics, event, params ? params : {});
  }
}

export function getLocalTimestamp(utcDate) {
  if (!utcDate) {
    return "";
  }

  const date = new Date(utcDate);
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
}

export function formatDate(date) {
  if (!date) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 to 12 for 12AM

  return `${year}-${month}-${day}, ${hours}:${minutes} ${ampm}`;
}

export function generateColorForChip(label) {
  const colorPalette = [
    "#141414", // Dark grey
    "#292929", // Medium-dark grey
    "#3d3d3d", // Medium grey

    // Primary shades that are dark enough for white backgrounds
    "#1F2A40", // Dark greyish blue
    "#141b2d", // Very dark blue

    // GreenAccent shades that are dark enough for white backgrounds
    "#4cceac", // Bright green
    "#3da58a", // Medium green
    "#2e7c67", // Dark green

    // RedAccent shades that are dark enough for white backgrounds
    "#db4f4a", // Red
    "#af3f3b", // Medium dark red
    "#832f2c", // Dark red

    // BlueAccent shades that are dark enough for white backgrounds
    "#6870fa", // Bright blue
    "#535ac8", // Medium dark blue
    "#3e4396", // Dark blue
  ];

  const hashCode = Array.from(label).reduce(
    (acc, char) => acc + char.charCodeAt(0),
    0
  );
  return colorPalette[hashCode % colorPalette.length];
}
